/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * User Registers API
 * API for user pre-registration and email verification
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Create a pre-registration record and send verification email
 */
export const createUserPreRegistrationBodyEmailMax = 255;

export const createUserPreRegistrationBodyNicknameMax = 50;

export const createUserPreRegistrationBodyPasswordMin = 6;
export const createUserPreRegistrationBodyPasswordMax = 100;

export const CreateUserPreRegistrationBody = zod
    .object({
        email: zod.string().email().max(createUserPreRegistrationBodyEmailMax),
        nickname: zod.string().max(createUserPreRegistrationBodyNicknameMax),
        password: zod
            .string()
            .min(createUserPreRegistrationBodyPasswordMin)
            .max(createUserPreRegistrationBodyPasswordMax),
    })
    .strict();

export const createUserPreRegistration201ResponseTokenMax = 36;

export const CreateUserPreRegistration201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        token: zod.string().max(createUserPreRegistration201ResponseTokenMax).optional(),
        verify_url: zod.string().optional(),
        email_sent: zod.boolean().optional(),
        message: zod.string().nullish(),
    })
    .strict();

/**
 * @summary Verify a pre-registration token and create the user
 */
export const verifyUserRegistrationTokenQueryTokenMin = 36;
export const verifyUserRegistrationTokenQueryTokenMax = 36;

export const VerifyUserRegistrationTokenQueryParams = zod
    .object({
        token: zod.string().min(verifyUserRegistrationTokenQueryTokenMin).max(verifyUserRegistrationTokenQueryTokenMax),
    })
    .strict();

export const VerifyUserRegistrationToken200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        user_id: zod.number().optional(),
        mypage_url: zod.string().optional(),
        login_url: zod.string().optional(),
        message: zod.string().nullish(),
    })
    .strict();
